<template>
  <div>
    <div v-if="done">
      <div class="ui success message">
        <i class="thumbs up outline icon"></i>
        发送成功！(可以安全地关闭页面，或者点击下面的按钮再次提交）
      </div>
      <button class="ui teal button" @click="refresh">
        再次提交
      </button>
    </div>
    <div v-else>
      <div class="ui info message">
        <i class="bolt icon"></i>
        文件闪传：快速上传文件到
        <a class="font-bold" href="/">红豆云</a>。
      </div>
      <img :src="qrcode_url" class="ui bordered image my-8 mx-auto" alt=""/>
      <div class="text-center">
        <a :href="ingress_url" target="_blank" class="ui basic teal large button">
          {{ ingress_url }}
        </a>
      </div>
      <div class="ui segments" v-if="tasks.length">
        <div v-for="(t, index) in tasks" :key="index"
             :class="task_class(t)"
             class="ui segment">
          <a @click="remove_task(index)" data-tooltip="移除">
            <i class="red times icon"></i>
          </a>
          <strong class="mr-2">
            {{ t.relative_path }}
          </strong>
          <span class="ui text" :class="task_class(t)">
            {{ t.percent }}%
          </span>
          <span class="ui red error text" v-if="t.failed">
            {{ t.error }}
          </span>
          <span class="ui red error text" v-if="t.ingress_error">
            {{ t.ingress_error }}
          </span>
        </div>
      </div>
      <hr>
      <div class="ui input w-full my-2">
        <label class="ui icon button" for="upload">
          <i class="upload icon"></i>
          添加文件
        </label>
        <label class="ui icon button" for="upload-dir">
          <i class="folder icon"></i>
          添加文件夹
        </label>
        <input type="file" multiple id="upload" name="upload" ref="upload" @change="handle_upload" style="display:none;">
        <input type="file" multiple webkitdirectory id="upload-dir" name="upload-dir" @change="handle_upload" style="display:none;">
      </div>
      <div class="my-2 ui segment">
        <DocEditor v-model="text"
                   placeholder="输入消息"
                   class="border-solid"
                   />
      </div>
      <div class="ui input w-full my-2">
        <button :disabled="submitting" :class="{loading:submitting}" class="ui teal button" @click="submit">
          提交
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcode';
import { IngressUploadTask } from '../libpepper';
import DocEditor from '../components/editor';

export default {
  name: 'IngressUploadPage',
  props: [],
  components: {
    DocEditor,
  },
  data: function () {
    return {
      done: false,
      submitting: false,
      text: '',
      tasks: [],
    };
  },
  computed: {
    ingress_url() {
      return window.location.href;
    },
    code() {
      return this.$route.params.code;
    },
  },
  asyncComputed: {
    qrcode_url() {
      return QRCode.toDataURL(window.location.href);
    },
  },
  methods: {
    task_class(t) {
      if (t.succeeded) {
        return "green";
      } else if (t.failed) {
        return "red";
      }
    },
    refresh() {
      window.location.reload(false);
    },
    remove_task(i) {
      this.show_confirm({
        message: "确定删除吗？",
        title: "删除闪传文件",
        ok: () => {
          this.tasks.splice(i, 1);
        },
      });
    },
    handle_upload(e) {
      this.$gtag.event('ingress-upload', {
        event_category: 'user-action',
      });
      var r = this.upload(e.target.files);
      e.target.value = "";
      return r;
    },
    upload(files) {
      files.forEach(f => {
        var task = new IngressUploadTask(this.code, this.client, f);
        this.tasks.push(task);
        task.start();
      });
    },
    async submit() {
      if (this.tasks.filter(t => t.running).length) {
        this.show_error("请等待上传完成后再提交");
        return;
      }
      if (this.tasks.filter(t => t.failed).length) {
        this.show_error("请删除上传失败的文件后提交");
        return;
      }
      var names = new Set();
      for (var t of this.tasks) {
        var rp = t.relative_path;
        if (names.has(rp)) {
          var e = "文件重复，请删除同名文件后提交";
          t.ingress_error = e;
          this.$forceUpdate()
          e = "文件重复，请删除同名文件后提交: " + rp;
          this.show_error(e);
          return;
        }
        names.add(rp);
      }
      this.submitting = true;
      var files = this.tasks.map(t => {
        return {
          path: t.relative_path,
          size: t.file.size,
          chunks: t.file_obj.data.chunks,
          enc_info: t.file_obj.enc_info.json,
        };
      });
      var data = {
        text: this.text,
        files
      };
      try {
        await this.client.ingress_submit(this.code, data,
          this.tasks.map(x => x.file_obj));
        this.done = true;
      } catch (e) {
        this.show_error(this.error_text(e));
      } finally {
        this.submitting = false;
      }
    },
    close() {
      window.close();
    },
  },
  mounted() {
  },
}
</script>

<style>
#editor {
  border: none;
  box-shadow: none;
}
hr {
  margin-top: 20px;
  margin-bottom: 20px;
}
.ui.error.text {
  margin-left: 1rem;
}
</style>

